import withPopover, { Popover } from "Components/withPopover";
import { BASE_ELEMENT_IGNORED_FIELDS } from "Components/withPopover/types/popoverProps";
import classNames from "classnames";
import omit from "lodash/omit";
import React, { useMemo, useRef } from "react";
import YesNoConfirmationInner from "./yesNoConfirmation.inner";
export default function YesNoConfirmation(props) {
    const defaultPopoverRef = useRef(null);
    const popoverRef = props.popoverRef || defaultPopoverRef;
    const popoverContent = useMemo(() => (React.createElement(YesNoConfirmationInner, { title: props.title, description: props.description, onConfirm: props.onConfirm, yesLabel: props.yesLabel, noLabel: props.noLabel, headerTitle: props.headerTitle, popoverRef: popoverRef })), [props.title, props.description, props.yesLabel, props.noLabel, props.onConfirm]);
    const Comp = useMemo(() => props.children
        ? withPopover((innerProps) => props.children
            ? React.cloneElement(props.children, omit(innerProps, BASE_ELEMENT_IGNORED_FIELDS))
            : React.createElement("div", omit(innerProps, BASE_ELEMENT_IGNORED_FIELDS)))
        : Popover, [props.children]);
    return (React.createElement(Comp, { popoverClassName: classNames(props.className, "confirmation-dialog", !props.children && "confirmation-dialog-as-modal bg-blur dx-overlay-shader"), showEvent: props.showEvent, position: props.position, popoverContent: popoverContent, popoverRef: popoverRef, disabled: props.disabled, container: props.container, zIndex: props.zIndex, hideOnOutsideClick: props.hideOnOutsideClick, hideOnParentScroll: props.hideOnParentScroll, popoverWidth: props.width }));
}
YesNoConfirmation.defaultProps = {
    position: {
        my: "right top",
        at: {
            x: "right",
            y: "bottom"
        }
    },
    container: document.body,
    disabled: false,
    showEvent: "click",
    hideOnOutsideClick: true,
    hideOnParentScroll: true
};
